import { Typography } from '../Typography';

type Props = {
  onChange: (value: string) => void;
  presetValues: {
    value: string;
    title?: string;
  }[];
  max: number;
};

export const AmountPresetButtons = ({ onChange, presetValues, max }: Props) => {
  const onClickMaxHandler = () => {
    onChange(String(max));
  };

  const onClickHandler = (value: string) => {
    return () => {
      onChange(value);
    };
  };

  return (
    <div className="flex w-full justify-between gap-2">
      {presetValues.map(({ value, title = value }) => {
        return (
          <button
            type="button"
            className="msq-btn msq-btn-secondary msq-btn-sm flex-grow"
            key={value}
            onClick={onClickHandler(value)}
          >
            <Typography variant="caption-xss-strong">{title}</Typography>
          </button>
        );
      })}
      <button
        type="button"
        className="msq-btn msq-btn-secondary msq-btn-sm flex-grow"
        key="max-button"
        onClick={onClickMaxHandler}
      >
        <Typography variant="caption-xss-strong">Max</Typography>
      </button>
    </div>
  );
};
